import { customAlphabet } from 'nanoid';

export function generateTraceIdSegment(): string {
  const ts = Math.floor(Date.now() / 1000);
  const tsHex = ts.toString(16);
  const rndHex = customAlphabet('1234567890abcdef', 24)();
  return tsHex + rndHex;
}
